var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"outlined":"","small":_vm.small,"dark":_vm.chipAttribute.dark,"color":_vm.chipAttribute.color}},[_vm._v(_vm._s(_vm.chipAttribute.text))])}
var staticRenderFns = []

export { render, staticRenderFns }